module.exports = __webpack_public_path__ + "img/all.0776d2ef.svg";